import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Studentaddfrom from "./studentaddfrom";
import FollowUpForm from "./Followupdata";
import {
  DeleteMarketingStudent,
  MarketingStudentList,
  excelimport,
  CreateMarketingSchool,
  GetMarketingSchool,
  CreateMarketingStudent,
} from "../../../api/MarketinService";
import Swal from "sweetalert2";
import {
  closeModal,
  ToastMain,
  SweetAlertShow,
  LoadingDiv,
} from "../../master/Master";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getSessions } from "../../../api/SessionsService";
import DownloadExcel from "../../master/DownloadExcel";
import MarketingHeader from "./MarketingHeader";

const Allstudent = () => {
  const hasAccess = usePrivateLink();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [student, setStudent] = useState([]);
  const [search, setSearch] = useState("");
  const [session, setSession] = useState("");
  const [Selectedsession, setSelectedSession] = useState("");
  const [area, setArea] = useState("");
  const [source, setSource] = useState("");
  const [Selectedsource, setSelectedSource] = useState("");
  const [HostelId, setHostelId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [sourceId, setSourceId] = useState("");
  const [file, setFile] = useState(null);
  const [responseMsg, setResponseMsg] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [status, setStatus] = useState("");
  const [course_id, setCourseId] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [rowErrors, setRowErrors] = useState({});
  const [selectedSession, setSelectedSessions] = useState("");
  const [statuses, setStatuses] = useState([]);
  const [batch, setBatch] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [delay, setDelay] = useState(1000);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [startDate, setStartDate] = useState(
    queryParams.get("start_date") || "",
  );
  const [selectedBatchId, setSelectedBatchId] = useState("");

  const getSession = async () => {
    try {
      const response = await getSessions();

      if (response.data.status) {
        const activeSession = response?.data?.data?.find(
          (s) => s?.status === "1",
        );

        setSelectedSession(activeSession?.id);
        setSession(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    }
  };

  const fetchStudent = async () => {
    let addUrl = `&session=${Selectedsession}&search=${search}&area=${area}&source_id=${Selectedsource}&page=${page}`;

    setLoading(true);

    try {
      const response = await MarketingStudentList(addUrl);

      if (response.data.status) {
        setStudent(response?.data?.data);
      } else {
        setError("Failed to fetch courses.");

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow("error", "Error", err?.response?.message ?? err?.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteStudent = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await DeleteMarketingStudent(id);

          console.log("student deleted", response.data);

          fetchStudent();

          SweetAlertShow("success", "Successfully", response?.data?.message);
        } catch (error) {
          SweetAlertShow(
            "error",
            "Error",
            error?.response?.data?.message ?? error?.message,
          );
        }
      }
    });
  };

  useEffect(() => {
    fetchStudent();
  }, [Selectedsession, search, Selectedsource, area, page]);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    formData.append("file", file);

    try {
      const res = await CreateMarketingStudent(formData);

      console.log("Excel import response:", res.data);

      if (res.data) {
        ToastMain.fire({
          icon: "success",
          title: "upload Successfully!",
        }).then(() => {
          closeModal("statusChange");
          fetchStudent();
        });
      } else {
        SweetAlertShow("info", "Warning", res?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);


  const handleDummyDownload = () => {
    const data = [
      [
        "name",
        "fathers_name",
        "mobile",
        "source_id",
        "course_id",
        "edu_level",
        "alternate_no",
        "village",
        "state",
        "district",
        "pincode",
        "description",
        "session_id",
      ],
      [
        "seema",
        "Ram",
        "1234567890",
        "9876543210",
        "Rajasthan",
        "jaipur",
        "amber",
        "chomu",
        "chomu",
        "House no.14",
        "12th Pass",
        "okkk",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(fileData, "Student-Template.xlsx");
  };

  useEffect(() => {
    if (Selectedsession) {
      setSelectedSource("");
      getSource();
    }
  }, [Selectedsession]);

  const getSource = async () => {
    try {
      const response = await GetMarketingSchool(
        `&session=${Selectedsession}`
      );

      console.log("Source List:", response.data);

      if (response?.data) {
        setSource(response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      console.error("API Error:", error);

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    }
  };

  const handleDownloadAll = async () => {
    try {
      let addUrl = `&session=${Selectedsession}`;

      if (area) addUrl += `&area=${area}`;
      if (Selectedsource) addUrl += `&source_id=${Selectedsource}`;
      if (page) addUrl += `&page=${page}`;
      if (search) addUrl += `&search=${search}`;

      setLoading(true);

      let allData = [];

      const firstResponse = await MarketingStudentList(`${addUrl}&page=1`);

      const lastPage = firstResponse?.data?.data?.last_page || 1;

      for (let p = 1; p <= lastPage; p++) {
        const response = await MarketingStudentList(`${addUrl}&page=${p}`);

        const records = response?.data?.data?.data || [];

        allData.push(...records);
      }

      if (allData.length === 0) {
        alert("No data found to export!");
        return;
      }

      const formattedData = allData.map((item, index) => ({
        "Sr #": index + 1,
        "Student Name": item.name || "",
        "Father’s Name": item.fathers_name || "",
        Mobile: item.mobile || "",
        District: item.district || "",
        Village: item.village || "",
        Pincode: item.pincode || "",
        "Created By": item.created_by || "",
        Status:
          item.status === "1"
            ? "Active"
            : item.status === "3"
              ? "Deleted"
              : "Other",
        "Created At": item.created_at
          ? new Date(item.created_at).toLocaleString()
          : "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Marketing_List");

      worksheet["!cols"] = Object.keys(formattedData[0]).map(() => ({
        wch: 20,
      }));

      XLSX.writeFile(workbook, "Marketing_List.xlsx");

      alert(`✅ Exported ${allData.length} records successfully!`);
    } catch (error) {
      console.error("Export error:", error);

      alert(`❌ Error while exporting: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    setSelectedFile(file);

    const reader = new FileReader();

    reader.onload = (event) => {
      const binaryStr = event.target.result;

      const workbook = XLSX.read(binaryStr, {
        type: "binary",
      });

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const rows = XLSX.utils.sheet_to_json(sheet, {
        raw: false,
      });

      setExcelData(rows);
      setStatuses(Array(rows.length).fill("pending"));
      setCurrentIndex(0);
    };

    reader.readAsBinaryString(file);
  };

  const updateStatus = (index, status) => {
    setStatuses((prev) => {
      const newStatuses = [...prev];

      newStatuses[index] = status;

      return newStatuses;
    });
  };

  const formatDate = (excelDate) => {
    if (!excelDate) return "";

    if (typeof excelDate === "string") {
      const parsed = new Date(excelDate);

      if (!isNaN(parsed)) {
        return parsed.toISOString().split("T")[0];
      }

      return excelDate;
    }

    if (typeof excelDate === "number") {
      const date = new Date((excelDate - 25569) * 86400 * 1000);

      if (!isNaN(date)) {
        return date.toISOString().split("T")[0];
      }

      return "";
    }

    return "";
  };

  const uploadRow = async (index) => {
    const row = { ...excelData[index] };

    if (selectedBatch) {
      row.batch_id = selectedBatch;
    }

    const formData = new FormData();

    Object.entries(row).forEach(([key, val]) => {
      if (key === "admission_date") {
        formData.append(key, formatDate(val));
      } else {
        formData.append(key, val ?? "");
      }
    });

    try {
      const res = await excelimport(formData);

      if (res.status === false && res.errors) {
        updateStatus(index, "failed");

        setRowErrors((prev) => ({
          ...prev,
          [index]: res.errors,
        }));

        return;
      }

      updateStatus(index, "success");
    } catch (error) {
      console.error(`Upload failed for row ${index}`, error);

      updateStatus(index, "failed");

      if (error.response?.data?.errors) {
        setRowErrors((prev) => ({
          ...prev,
          [index]: error.response.data.errors,
        }));
      }
    }
  };

  const handleUpload = async () => {
    if (!excelData.length) return alert("No data");

    const processRow = async (index) => {
      if (index >= excelData.length) {
        setLoading(false);
        return;
      }

      if (statuses[index] === "pending") {
        await uploadRow(index);

        await new Promise((res) => setTimeout(res, delay));
      }

      if (statuses[index] === "failed") {
        setCurrentIndex(index);
        return;
      }

      setCurrentIndex(index + 1);

      await processRow(index + 1);
    };

    processRow(currentIndex);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => prev + 1);
    handleUpload();
  };

  const handleRepair = (index) => {
    updateStatus(index, "pending");

    setRowErrors((prev) => {
      const updated = { ...prev };

      delete updated[index];

      return updated;
    });

    setCurrentIndex(index);

    handleUpload();
  };

  const countStatus = (type) =>
    statuses.filter((status) => status === type).length;

  const handleDownloadFormat = () => {
    const data = [
      [
        "name",
        "fathers_name",
        "mobile",
        "alternate_no",
        "state",
        "district",
        "block",
        "village",
        "pincode",
        "address",
        "edu_level",
        "description",
      ],
      ,
      [
        "name",
        "fathers_name",
        "mobile",
        "alternate_no",
        "state",
        "district",
        "block",
        "village",
        "pincode",
        "address",
        "edu_level",
        "description",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, "students_template.xlsx");
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid py-3">
                <div className="row g-4">
                  {/* =====================================================
                      MARKETING HEADER
                  ====================================================== */}
                  <div className="col-12">
                    <MarketingHeader />
                  </div>

                  {/* =====================================================
                      PAGE HEADER + FILTERS
                  ====================================================== */}
                  <div className="col-12">
                    <div className="card border-0 shadow-sm overflow-hidden">
                      {/* Header */}
                      <div className="card-header bg-transparent border-bottom px-4 py-3">
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                          <div className="d-flex align-items-center gap-3">
                            <div
                              className="rounded-3 bg-primary text-white d-flex align-items-center justify-content-center"
                              style={{
                                width: "48px",
                                height: "48px",
                                flexShrink: 0,
                              }}
                            >
                              <i className="ri-group-line fs-4"></i>
                            </div>

                            <div>
                              <h4 className="mb-1 fw-bold">All Students</h4>

                              <p className="mb-0 text-muted small">
                                Manage and maintain your marketing student
                                records
                              </p>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <span className="badge bg-primary text-white rounded-pill px-3 py-2">
                              <i className="ri-group-line me-1"></i>
                              {student?.total || 0} Students
                            </span>

                            {hasAccess("/marketing/students/export") && (
                              <button
                                type="button"
                                className="btn btn-success d-flex align-items-center gap-2"
                                onClick={handleDownloadAll}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Export Excel"
                              >
                                <i className="ri-file-excel-2-line"></i>
                                <span className="d-none d-md-inline">
                                  Export
                                </span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Filters */}
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center gap-2 mb-4">
                          <div className="text-primary">
                            <i className="ri-filter-3-line fs-5"></i>
                          </div>

                          <div>
                            <h6 className="mb-0 fw-bold">Student Filters</h6>

                            <small className="text-muted">
                              Filter students by session, source or location
                            </small>
                          </div>
                        </div>

                        <div className="row g-3">
                          {/* Session */}
                          <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                name="session"
                                value={Selectedsession}
                                onChange={(e) =>
                                  setSelectedSession(e.target.value)
                                }
                              >
                                {session?.data?.map((sess) => (
                                  <option key={sess.id} value={sess.id}>
                                    {sess.session} :{" "}
                                    {sess.status === "1"
                                      ? "Active"
                                      : "Inactive"}
                                  </option>
                                ))}
                              </select>

                              <label>
                                <i className="ri-calendar-line me-1"></i>
                                Select Session
                              </label>
                            </div>
                          </div>

                          {/* Student Name */}
                          <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                name="search"
                                placeholder="student name"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                              />

                              <label>
                                <i className="ri-user-search-line me-1"></i>
                                Student Name
                              </label>
                            </div>
                          </div>

                          {/* Source */}
                          <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                name="source_id"
                                value={Selectedsource}
                                onChange={(e) =>
                                  setSelectedSource(e.target.value)
                                }
                              >
                                <option value="">Select Source</option>

                                {source?.data?.map((sch) => (
                                  <option key={sch.id} value={sch.id}>
                                    {sch.source_name}
                                  </option>
                                ))}
                              </select>

                              <label>
                                <i className="ri-megaphone-line me-1"></i>
                                Source Name
                              </label>
                            </div>
                          </div>

                          {/* Address */}
                          <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                name="area"
                                placeholder="search address"
                                value={area}
                                onChange={(e) => setArea(e.target.value)}
                              />

                              <label>
                                <i className="ri-map-pin-line me-1"></i>
                                Address
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* Active filters */}
                        {(search ||
                          Selectedsource ||
                          area ||
                          Selectedsession) && (
                            <div className="border-top mt-4 pt-3">
                              <div className="d-flex flex-wrap align-items-center gap-2">
                                <span className="text-muted small fw-semibold">
                                  <i className="ri-filter-line me-1"></i>
                                  Active Filters:
                                </span>

                                {Selectedsession && (
                                  <span className="badge bg-primary text-white rounded-pill px-3 py-2">
                                    <i className="ri-calendar-line me-1"></i>
                                    Session
                                  </span>
                                )}

                                {search && (
                                  <span className="badge bg-info text-white rounded-pill px-3 py-2">
                                    <i className="ri-search-line me-1"></i>
                                    {search}
                                  </span>
                                )}

                                {Selectedsource && (
                                  <span className="badge bg-warning text-dark rounded-pill px-3 py-2">
                                    <i className="ri-megaphone-line me-1"></i>
                                    Source
                                  </span>
                                )}

                                {area && (
                                  <span className="badge bg-success text-white rounded-pill px-3 py-2">
                                    <i className="ri-map-pin-line me-1"></i>
                                    {area}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>

                  {/* =====================================================
                      STUDENT TABLE
                  ====================================================== */}
                  <div className="col-12">
                    <div className="card border-0 shadow-sm overflow-hidden">
                      {/* Table Header */}
                      <div className="card-header bg-transparent border-bottom px-4 py-3">
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                          <div className="d-flex align-items-center gap-3">
                            <div
                              className="rounded-3 bg-success text-white d-flex align-items-center justify-content-center"
                              style={{
                                width: "44px",
                                height: "44px",
                                flexShrink: 0,
                              }}
                            >
                              <i className="ri-group-line fs-5"></i>
                            </div>

                            <div>
                              <h5 className="mb-1 fw-bold">Student Records</h5>

                              <p className="mb-0 text-muted small">
                                View, edit or remove marketing students
                              </p>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <span className="badge bg-light text-body border rounded-pill px-3 py-2">
                              <i className="ri-file-list-3-line me-1"></i>
                              {student?.data?.length || 0} on this page
                            </span>

                            <span className="badge bg-primary text-white rounded-pill px-3 py-2">
                              {student?.total || 0} Total
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Table */}
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-hover align-middle mb-0">
                            <thead className="table-primary sticky-top">
                              <tr>
                                <th className="ps-4 text-nowrap">#</th>

                                <th className="text-nowrap">
                                  <i className="ri-user-line me-1"></i>
                                  Name
                                </th>

                                <th className="text-nowrap">
                                  <i className="ri-phone-line me-1"></i>
                                  Mobile
                                </th>

                                <th className="text-nowrap">Father's Name</th>

                                <th className="text-nowrap">
                                  <i className="ri-map-pin-line me-1"></i>
                                  Address
                                </th>

                                <th className="text-nowrap">Education Level</th>

                                <th className="text-nowrap">
                                  <i className="ri-sticky-note-line me-1"></i>
                                  Note
                                </th>

                                <th className="text-nowrap text-center">
                                  Source
                                </th>
                                <th className="text-nowrap text-center">
                                  Status
                                </th>

                                <th className="text-nowrap text-center pe-4">
                                  Action
                                </th>
                              </tr>
                            </thead>

                            <tbody className="text-capitalize">
                              {student?.data?.length === 0 ? (
                                <tr>
                                  <td colSpan="9">
                                    <div className="text-center py-5">
                                      <div
                                        className="mx-auto mb-3 rounded-circle bg-light d-flex align-items-center justify-content-center text-muted"
                                        style={{
                                          width: "64px",
                                          height: "64px",
                                        }}
                                      >
                                        <i className="ri-user-search-line fs-2"></i>
                                      </div>

                                      <h6 className="fw-bold mb-1">
                                        No Students Found
                                      </h6>

                                      <p className="text-muted small mb-0">
                                        No student records match the selected
                                        filters.
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                student?.data?.map((std, index) => (
                                  <tr key={index}>
                                    {/* Serial */}
                                    <td className="ps-4 fw-semibold text-muted">
                                      {index + 1}
                                    </td>

                                    {/* Name */}
                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <div
                                          className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "34px",
                                            height: "34px",
                                            minWidth: "34px",
                                          }}
                                        >
                                          {std?.name
                                            ?.charAt(0)
                                            ?.toUpperCase() || "S"}
                                        </div>

                                        <div>
                                          <div className="fw-semibold">
                                            {std.name || "N/A"}
                                          </div>
                                        </div>
                                      </div>
                                    </td>

                                    {/* Mobile */}
                                    <td className="text-nowrap">
                                      {std.mobile ? (
                                        <span>
                                          <i className="ri-phone-line text-success me-1"></i>
                                          {std.mobile}
                                        </span>
                                      ) : (
                                        "N/A"
                                      )}
                                    </td>

                                    {/* Father */}
                                    <td>{std.fathers_name || "N/A"}</td>

                                    {/* Address */}
                                    <td>
                                      <div
                                        className="text-muted"
                                        style={{
                                          minWidth: "180px",
                                          maxWidth: "260px",
                                        }}
                                      >
                                        {std.village || "N/A"}

                                        {std?.district && <> {std.district}</>}

                                        {std?.state && <>, {std.state}</>}

                                        {std?.pincode && (
                                          <div className="small text-muted mt-1">
                                            <i className="ri-map-pin-2-line me-1"></i>
                                            {std.pincode}
                                          </div>
                                        )}
                                      </div>
                                    </td>

                                    {/* Education */}
                                    <td>
                                      <span className="badge bg-info text-white rounded-pill px-3 py-2">
                                        {std.edu_level || "N/A"}
                                      </span>
                                    </td>

                                    {/* Note */}
                                    <td>
                                      <div
                                        className="text-muted"
                                        style={{
                                          minWidth: "150px",
                                          maxWidth: "220px",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {std.description || "N/A"}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-center">
                                        <span className="badge bg-warning text-dark rounded-pill px-3 py-2">
                                          {std?.source?.source_name || "N/A"}
                                        </span>
                                      </div>
                                    </td>

                                    {/* Status */}
                                    <td className="text-center">
                                      {std.status === "1" ? (
                                        <span className="badge bg-success text-white rounded-pill px-3 py-2">
                                          <i className="ri-checkbox-circle-line me-1"></i>
                                          Active
                                        </span>
                                      ) : (
                                        <span className="badge bg-secondary text-white rounded-pill px-3 py-2">
                                          <i className="ri-close-circle-line me-1"></i>
                                          Inactive
                                        </span>
                                      )}
                                    </td>

                                    {/* Actions */}
                                    <td className="text-center pe-4">
                                      <div className="d-flex justify-content-center align-items-center gap-2">
                                        {hasAccess(
                                          "/marketing/update_student",
                                        ) && (
                                            <Link
                                              className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1"
                                              to="/marketing/update_student"
                                              state={{ id: std }}
                                              title="Edit Student"
                                            >
                                              <i className="ri-pencil-line"></i>
                                              <span className="d-none d-xl-inline">
                                                Edit
                                              </span>
                                            </Link>
                                          )}

                                        {hasAccess(
                                          "/marketing/student/delete",
                                        ) && (
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1"
                                              onClick={() =>
                                                deleteStudent(std.id)
                                              }
                                              title="Delete Student"
                                            >
                                              <i className="ri-delete-bin-line"></i>
                                              <span className="d-none d-xl-inline">
                                                Delete
                                              </span>
                                            </button>
                                          )}
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* Pagination Footer */}
                      <div className="card-footer bg-transparent border-top px-4 py-3">
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                          <div className="text-muted small">
                            <i className="ri-information-line me-1"></i>
                            Showing{" "}
                            <strong className="text-body">
                              {student?.from || 0}
                            </strong>{" "}
                            to{" "}
                            <strong className="text-body">
                              {student?.to || 0}
                            </strong>{" "}
                            of{" "}
                            <strong className="text-body">
                              {student?.total || 0}
                            </strong>{" "}
                            entries
                          </div>

                          <nav aria-label="Page navigation">
                            <ul className="pagination pagination-sm mb-0">
                              {student?.links?.map((btn, i) => (
                                <li
                                  key={`${btn?.label}-${i}`}
                                  className={`page-item ${btn?.active ? "active" : ""
                                    } ${btn?.url ? "" : "disabled"}`}
                                >
                                  <button
                                    type="button"
                                    className="page-link"
                                    onClick={() => {
                                      if (student?.links?.length === i + 1) {
                                        btn?.url &&
                                          setPage(student?.current_page + 1);
                                      } else if (i === 0) {
                                        btn?.url &&
                                          setPage(student?.current_page - 1);
                                      } else {
                                        setPage(btn.label);
                                      }
                                    }}
                                  >
                                    {student?.links?.length === i + 1 ? (
                                      <i className="ri-arrow-right-s-line"></i>
                                    ) : i === 0 ? (
                                      <i className="ri-arrow-left-s-line"></i>
                                    ) : (
                                      btn?.label
                                    )}
                                  </button>
                                </li>
                              ))}
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <Footer />

                <div className="content-backdrop fade"></div>
              </div>
            </div>
          </div>

          <div className="layout-overlay layout-menu-toggle"></div>
          <div className="drag-target"></div>
        </div>
      </div>

      {/* ============================================================
          ADD STUDENT MODAL
      ============================================================= */}
      <div
        className="modal fade"
        id="ADDNewstudent"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content border-0 shadow-lg">
            <div className="modal-header border-bottom px-4 py-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded-3 bg-primary text-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "42px",
                    height: "42px",
                  }}
                >
                  <i className="ri-user-add-line fs-5"></i>
                </div>

                <div>
                  <h5
                    className="modal-title fw-bold mb-0"
                    id="exampleModalLabel"
                  >
                    Add New Student
                  </h5>

                  <small className="text-muted">
                    Enter student information
                  </small>
                </div>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body p-4">
              <Studentaddfrom />
            </div>

            <div className="modal-footer border-top">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button type="button" className="btn btn-primary">
                <i className="ri-save-line me-1"></i>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ============================================================
          UPDATE STUDENT MODAL
      ============================================================= */}
      <div
        className="modal fade"
        id="editNewstudent"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content border-0 shadow-lg">
            <div className="modal-header border-bottom px-4 py-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded-3 bg-primary text-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "42px",
                    height: "42px",
                  }}
                >
                  <i className="ri-user-settings-line fs-5"></i>
                </div>

                <div>
                  <h5
                    className="modal-title fw-bold mb-0"
                    id="exampleModalLabel"
                  >
                    Update Student
                  </h5>

                  <small className="text-muted">
                    Update student information
                  </small>
                </div>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body p-4">
              <div className="container-fluid">
                <form>
                  <div className="row g-3">
                    <div className="col-12">
                      <label className="form-label fw-semibold">
                        School Name
                      </label>

                      <select className="form-select">
                        <option>Select School</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Student Name
                      </label>

                      <textarea className="form-control" rows={2}></textarea>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Father's Name
                      </label>

                      <textarea className="form-control" rows={2}></textarea>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Mobile No
                      </label>

                      <textarea className="form-control" rows={2}></textarea>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Other Mobile
                      </label>

                      <textarea className="form-control" rows={2}></textarea>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">
                        Education Level
                      </label>

                      <select className="form-select">
                        <option>12th Pass</option>
                        <option>10th Pass</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Village</label>

                      <textarea className="form-control" rows={2}></textarea>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Tehsil</label>

                      <textarea className="form-control" rows={2}></textarea>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">State</label>

                      <select className="form-select">
                        <option>Select State</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">District</label>

                      <select className="form-select">
                        <option>Select District</option>
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Block</label>

                      <select className="form-select">
                        <option>Select Block</option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="modal-footer border-top">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button type="button" className="btn btn-primary">
                <i className="ri-save-line me-1"></i>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ============================================================
          FOLLOW UP MODAL
      ============================================================= */}
      <div
        className="modal fade"
        id="FollowupFrom"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content border-0 shadow-lg">
            <div className="modal-header border-bottom px-4 py-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded-3 bg-success text-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "42px",
                    height: "42px",
                  }}
                >
                  <i className="ri-phone-line fs-5"></i>
                </div>

                <div>
                  <h5
                    className="modal-title fw-bold mb-0"
                    id="exampleModalLabel"
                  >
                    Student Follow Up
                  </h5>

                  <small className="text-muted">
                    Record follow-up information
                  </small>
                </div>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body p-4">
              <FollowUpForm />
            </div>

            <div className="modal-footer border-top">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button type="button" className="btn btn-primary">
                <i className="ri-save-line me-1"></i>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ============================================================
          EXCEL UPLOAD MODAL
      ============================================================= */}
      <div
        className="modal fade"
        id="excelUploadModal"
        tabIndex="-1"
        aria-labelledby="excelUploadModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg">
            {/* Excel Header */}
            <div className="modal-header border-bottom px-4 py-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="rounded-3 bg-success text-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "44px",
                    height: "44px",
                  }}
                >
                  <i className="ri-file-excel-2-line fs-5"></i>
                </div>

                <div>
                  <h5
                    className="modal-title fw-bold mb-1"
                    id="excelUploadModalLabel"
                  >
                    Excel Data Import
                  </h5>

                  <small className="text-muted">
                    Upload, review and process student records
                  </small>
                </div>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body p-4">
              {/* Upload Controls */}
              <div className="border rounded-3 p-3 mb-4">
                <div className="row g-3 align-items-end">
                  <div className="col-lg-5">
                    <label className="form-label fw-semibold">
                      <i className="ri-upload-cloud-2-line me-1"></i>
                      Select Excel File
                    </label>

                    <input
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleFileChange}
                      className="form-control"
                    />
                  </div>

                  <div className="col-lg-3">
                    <label className="form-label fw-semibold">
                      <i className="ri-stack-line me-1"></i>
                      Select Batch
                    </label>

                    <select
                      value={selectedBatch}
                      onChange={(e) => setSelectedBatch(e.target.value)}
                      className="form-select"
                    >
                      <option value="" disabled>
                        Select Batch
                      </option>

                      {batches?.map((batch) => (
                        <option key={batch?.id} value={batch?.id}>
                          {batch.title} ({batch?.course?.title})
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-2">
                    <label className="form-label fw-semibold">
                      <i className="ri-timer-line me-1"></i>
                      Delay
                    </label>

                    <select
                      value={delay}
                      onChange={(e) => setDelay(Number(e.target.value))}
                      className="form-select"
                    >
                      {[...Array(15)].map((_, i) => (
                        <option key={i} value={(i + 1) * 1000}>
                          {i + 1}s
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-2">
                    <button
                      type="button"
                      className="btn btn-outline-primary w-100"
                      onClick={handleDownloadFormat}
                    >
                      <i className="ri-download-2-line me-1"></i>
                      Template
                    </button>
                  </div>
                </div>
              </div>

              {/* Status Summary */}
              <div className="row g-3 mb-4">
                <div className="col-md-4">
                  <div className="border rounded-3 p-3 d-flex align-items-center gap-3">
                    <div
                      className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "40px",
                        height: "40px",
                      }}
                    >
                      <i className="ri-check-line"></i>
                    </div>

                    <div>
                      <div className="small text-muted">Success</div>

                      <div className="fw-bold fs-5">
                        {countStatus("success")}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="border rounded-3 p-3 d-flex align-items-center gap-3">
                    <div
                      className="rounded-circle bg-danger text-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "40px",
                        height: "40px",
                      }}
                    >
                      <i className="ri-close-line"></i>
                    </div>

                    <div>
                      <div className="small text-muted">Failed</div>

                      <div className="fw-bold fs-5">
                        {countStatus("failed")}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="border rounded-3 p-3 d-flex align-items-center gap-3">
                    <div
                      className="rounded-circle bg-warning text-dark d-flex align-items-center justify-content-center"
                      style={{
                        width: "40px",
                        height: "40px",
                      }}
                    >
                      <i className="ri-time-line"></i>
                    </div>

                    <div>
                      <div className="small text-muted">Pending</div>

                      <div className="fw-bold fs-5">
                        {countStatus("pending")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Excel Preview */}
              {excelData.length > 0 && (
                <div className="border rounded-3 overflow-hidden">
                  <div className="px-3 py-3 border-bottom d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="fw-bold mb-1">Excel Preview</h6>

                      <small className="text-muted">
                        {excelData.length} rows loaded
                      </small>
                    </div>

                    <span className="badge bg-primary text-white rounded-pill px-3 py-2">
                      Row {currentIndex + 1} / {excelData.length}
                    </span>
                  </div>

                  <div
                    className="table-responsive"
                    style={{
                      maxHeight: "420px",
                      overflowY: "auto",
                    }}
                  >
                    <table className="table table-bordered table-hover align-middle mb-0">
                      <thead
                        className="table-primary sticky-top"
                        style={{ zIndex: 5 }}
                      >
                        <tr>
                          <th
                            style={{
                              width: "55px",
                            }}
                          >
                            #
                          </th>

                          {Object.keys(excelData[0]).map((key, idx) => (
                            <th key={idx} className="text-nowrap">
                              {key}
                            </th>
                          ))}

                          <th className="text-center">Status</th>

                          <th className="text-center">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {excelData.map((row, idx) => (
                          <tr key={idx}>
                            <td className="fw-bold text-muted">{idx + 1}</td>

                            {Object.keys(row).map((key, i) => (
                              <td key={i}>
                                {statuses[idx] === "failed" ? (
                                  <div>
                                    <input
                                      type="text"
                                      className={`form-control form-control-sm ${rowErrors?.[idx]?.[key]
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                      value={row[key]}
                                      onChange={(e) => {
                                        const newData = [...excelData];

                                        newData[idx][key] = e.target.value;

                                        setExcelData(newData);
                                      }}
                                    />

                                    {rowErrors?.[idx]?.[key] && (
                                      <div className="invalid-feedback">
                                        {rowErrors[idx][key][0]}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  row[key]
                                )}
                              </td>
                            ))}

                            <td className="text-center">
                              {statuses[idx] === "success" && (
                                <span className="badge bg-success text-white rounded-pill">
                                  <i className="ri-check-line me-1"></i>
                                  Success
                                </span>
                              )}

                              {statuses[idx] === "failed" && (
                                <span className="badge bg-danger text-white rounded-pill">
                                  <i className="ri-close-line me-1"></i>
                                  Failed
                                </span>
                              )}

                              {statuses[idx] === "pending" && (
                                <span className="badge bg-warning text-dark rounded-pill">
                                  <i className="ri-time-line me-1"></i>
                                  Pending
                                </span>
                              )}
                            </td>

                            <td className="text-center">
                              {statuses[idx] === "failed" && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-info"
                                  onClick={() => handleRepair(idx)}
                                >
                                  <i className="ri-refresh-line me-1"></i>
                                  Retry
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {!excelData.length && (
                <div className="border border-dashed rounded-3 py-5 text-center">
                  <div
                    className="mx-auto mb-3 rounded-circle bg-success text-white d-flex align-items-center justify-content-center"
                    style={{
                      width: "64px",
                      height: "64px",
                    }}
                  >
                    <i className="ri-file-excel-2-line fs-2"></i>
                  </div>

                  <h6 className="fw-bold mb-1">No Excel File Selected</h6>

                  <p className="text-muted small mb-0">
                    Select an Excel file above to preview student records.
                  </p>
                </div>
              )}
            </div>

            {/* Excel Footer */}
            <div className="modal-footer border-top d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                <i className="ri-close-line me-1"></i>
                Cancel
              </button>

              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-warning"
                  onClick={() => {
                    const firstFailed = statuses.findIndex(
                      (s) => s === "failed",
                    );

                    if (firstFailed !== -1) {
                      setCurrentIndex(firstFailed);
                      handleUpload();
                    }
                  }}
                >
                  <i className="ri-refresh-line me-1"></i>
                  Retry Failed
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleUpload}
                  disabled={loading}
                >
                  <i className="ri-upload-cloud-2-line me-1"></i>

                  {loading ? "Uploading..." : "Start Upload"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Allstudent;
